export default __webpack_public_path__ + "static/browser_address_bar-ae71983170a707dda951502167a5e852.svg";